import { SeverityLevel } from './types';

export const LE_SUPPLIER_LABEL = 'Luxury Escapes';
export const BEST_COMPETITOR_LABEL = 'Best Competitor';
export const ALL_SEVERITY_FILTER = 'all';

export const OUT_OF_PARITY_HEALTHY_THRESHOLD = 2;

export const PARITY_THRESHOLD_MINOR = 0.02;
export const PARITY_THRESHOLD_MODERATE = 0.05;
export const PARITY_THRESHOLD_SEVERE = 0.1;

export const SEVERITY_COLORS: Record<SeverityLevel, string> = {
  in_parity: '#27ae60',
  minor: '#f39c12',
  moderate: '#e67e22',
  severe: '#e74c3c',
  no_data: '#bdc3c7',
  no_comparison: '#95a5a6',
};

export const SUPPLIER_CHIP_COLORS: Record<string, { bg: string; color: string; border: string }> = {
  'Booking.com': { bg: '#dbeafe', color: '#1e40af', border: '#93b4f5' },
  Expedia: { bg: '#fef3c7', color: '#92400e', border: '#f5c978' },
  Agoda: { bg: '#fae8ff', color: '#86198f', border: '#d98ce0' },
  'Direct Rates': { bg: '#d1fae5', color: '#065f46', border: '#7dd8b8' },
};

export const SEVERITY_ORDER: Array<string> = ['severe', 'moderate', 'minor'];

export const SEVERITY_CHIP_COLORS: Record<string, { bg: string; color: string; border: string }> = {
  minor: { bg: '#fef3c7', color: '#92400e', border: '#f39c12' },
  moderate: { bg: '#fed7aa', color: '#9a3412', border: '#e67e22' },
  severe: { bg: '#fee2e2', color: '#991b1b', border: '#e74c3c' },
};

export const CHART_LINE_COLORS: Record<string, string> = {
  'Booking.com': '#93b4f5',
  Expedia: '#f5c978',
  Agoda: '#d98ce0',
  'Direct Rates': '#7dd8b8',
};

export const LE_CHART_COLOR = '#000000';
export const BEST_COMPETITOR_CHART_COLOR = '#06b6d4';

export const LE_CHIP_STYLE = { bg: '#000000', color: '#ffffff', border: '#000000' } as const;
export const BEST_COMPETITOR_CHIP_STYLE = { bg: '#cff5fc', color: '#0e7490', border: '#06b6d4' } as const;

export const RATING_BADGE_STYLES: Record<string, { bgcolor: string; color: string; iconBg: string; icon: string }> = {
  GOOD: { bgcolor: '#dcfce7', color: 'success.main', iconBg: '#16a34a', icon: '✓' },
  FAIR: { bgcolor: '#fef3c7', color: 'warning.main', iconBg: '#d97706', icon: '!' },
  POOR: { bgcolor: '#fee2e2', color: 'error.main', iconBg: '#dc2626', icon: '!' },
  CRITICAL: { bgcolor: '#fee2e2', color: 'error.main', iconBg: '#dc2626', icon: '!' },
};

export const HEATMAP_COLORS = {
  good: { bgcolor: '#d1fae5', color: '#065f46' },
  minor: { bgcolor: '#fef3c7', color: '#92400e' },
  moderate: { bgcolor: '#fed7aa', color: '#9a3412' },
  severe: { bgcolor: '#fecaca', color: '#991b1b' },
} as const;

export const CARD_SX = {
  bgcolor: 'grey.50',
  p: 2.5,
  borderRadius: '12px',
  border: 1,
  borderColor: 'divider',
} as const;

export const SECTION_SX = {
  borderRadius: '16px',
  p: 4,
  mb: 3,
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
} as const;

export const SCORE_CARD_SX = {
  ...CARD_SX,
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
} as const;

export const HIGHLIGHTED_CARD_SX = {
  bgcolor: '#dcfce7',
  border: '1px solid #86efac',
  borderRadius: '12px',
  p: 3,
} as const;
